import { createRouter, createWebHistory } from 'vue-router'
import { i18n, setI18nLanguage } from '@/i18n'
import Cookie from 'vue-cookie'
import store from '@/store/index'

import DefaultLayout from '@/layout/DefaultLayout'
import Home from '@/views/Home';
import Diner from "../views/Diner";
import DriveThru from "../views/DriveThru";
import Elevator from "../views/Elevator";
import Kitchen from "../views/Kitchen";
import Rooftop from "../views/Rooftop";
import Slide from "../views/Slide";
import Vanity from "../views/Vanity";


const routes = [
  // {
  //   path: "/",
  //   beforeEnter(to, from, next) {
	// 		//if no lang in url get it from store
	// 		console.log('before', to, from)
  //     next("/"+store.state.activeLang);
  //   },
  //   component: DefaultLayout
  // },
  {
		path: '/:lang',
		name: 'Intro',
		component: DefaultLayout,
		children: [
			{
				path: '',
				name: 'Home',
				component: Home
			},
			{
				path: 'diner',
				name: 'Diner',
				component: Diner
			},
			{
				path: 'drive-thru',
				name: 'DriveThru',
				component: DriveThru
			},
			{
				path: 'elevator',
				name: 'Elevator',
				component: Elevator
			},
			{
				path: 'kitchen',
				name: 'Kitchen',
				component: Kitchen
			},
			{
				path: 'rooftop',
				name: 'Rooftop',
				component: Rooftop
			},
			{
				path: 'slide',
				name: 'Slide',
				component: Slide
			},
			{
				path: 'vanity',
				name: 'Vanity',
				component: Vanity
			}
		]
	}
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
	let selectedLang = null;
	let isAvail = false;

	//if the route has no params try the cookie
	if(Object.keys(to.params).length === 0) {
		selectedLang = Cookie.get('locale');
	} else {
		selectedLang = to.params.lang.toLowerCase();
		store.state.availableLangs.map(function(value) {
			if(value.lang == selectedLang) isAvail = true;
		});
	}
	if(selectedLang !== store.state.activeLang) {
		store.state.availableLangs.map(function(value) {
			if(value.lang == selectedLang) setI18nLanguage( i18n, value);
		});
	}

	if(isAvail) {
		return next()
	} else {
		next('/en');
	}

})

export default router
